require('./minimizeButtonToggle.component.scss');

class MinimizeButtonToggleController {
    constructor($document, $element, $timeout) {
        this.$document = $document;
        this.$element = $element;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.customKeyupFn = (e) => {
            if (angular.isUndefined(this.isMini)) return;
            if (!!this.$document.find('.modal-open .ctx-dialog-service-template')[0] || !!this.$document.find('.modal-open .ctx-modal-content')[0] || !!this.$document.find('.report-view-enter')[0] ||
                (document.activeElement && document.activeElement.type === 'search')) return;
            this.$timeout(() => {
                if (e.keyCode === 32) this.toggleMinimize();
            }, 0);
        };
        this.$document[0].addEventListener('keyup', this.customKeyupFn, false);
    }

    toggleMinimize() {
        this.isMini = !this.isMini;
        let height = '550px', toAdd = 'icon-Minimize', toRemove = 'icon-maximize';
        if (this.isMini) {
            height = '75px';
            toAdd = 'icon-maximize';
            toRemove = 'icon-Minimize';
        }
        this.$document.find(`#${this.customId}`).css('max-height', height);
        this.$element.find('.icon-min-max').removeClass(toRemove);
        this.$element.find('.icon-min-max').addClass(toAdd);
    }

    $onDestroy() {
        this.isMini = undefined;
        this.$document[0].removeEventListener('keyup', this.customKeyupFn, false);
    }
}

MinimizeButtonToggleController.$inject = ['$document', '$element', '$timeout'];
const minimizeButtonToggleComponent = {
    controller: MinimizeButtonToggleController,
    template: require('./minimizeButtonToggle.component.html'),
    bindings: {
        isMini: '=',
        customId: '@?'
    }
};

module.exports = minimizeButtonToggleComponent;



// WEBPACK FOOTER //
// ./src/shared/minimizeButtonToggle/minimizeButtonToggle.component.js